// @flow
import { get } from 'lodash';
import { constants } from '@clubmed/utils';

const { WINTER_MOUNTAIN_RESORT } = constants;

export function isWinterResort(resort: Resort): boolean {
  const seasons = get(resort, 'seasons', []);

  return (
    seasons.length === 1 &&
    seasons.includes('WINTER') &&
    get(resort, 'type', '').toUpperCase() === 'VILLAGE'
  );
}

export function isWinterMountainResort(resort: { +category: string }): boolean {
  return get(resort, 'category') === WINTER_MOUNTAIN_RESORT;
}

export const resortHasBeActivities = (resort: Resort) =>
  resort.activityCategories.leisure.some(({ subCategories }) => subCategories.length !== 0);
